import React, { useEffect } from 'react';
import { useState } from 'react';
import { useContext } from 'react';
import { UserContext } from '../../App';
import Header from '../Header/Header';
import { Table } from 'react-bootstrap';
import OrderDetails from '../../components/OrderDetails/OrderDetails'


const Orders = () => {


    const [ signInUser, setSignInUser]= useContext(UserContext);

    const [order,setOrder] = useState([]);

    const [addedOrder,setAddedOrder]=useState(false)

 

    


   



    useEffect(() => {

         
          fetch(`https://cryptic-plains-44743.herokuapp.com/orders?email=` +signInUser.email)
          .then(res => res.json())
          .then(data =>  {

              if(data){
                    setAddedOrder(data)
                }
                setOrder(data)
                })




          




    },[addedOrder])

    
   
    
    return (
        <div className="container">
        <Header></Header>

        
            <div style={{textAlign: 'center'}}>

                  <p>Hi!{signInUser.userName}</p>  



                   <h2>Your {order.length} Order Summary </h2>

                

                  


                  <Table responsive="sm">
                   
                        <tr>
                            <th>Product Image</th>
                            <th>Date</th>
                            <th>Name</th>
                            <th>Price</th>
                        </tr>
                   </Table>


                 
                    {
                      order.map(or => <OrderDetails or={or}></OrderDetails>)
                    }
                        
                      
               
            </div>
        </div>
    );
};

export default Orders;